// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"185":"b2e916cf","310":"358ff181"}[chunkId] + ".css";
};